import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useRouter } from "vue-router";
import { Brandlift } from "@/interfaces/Brandlift";
import { useToast } from "primevue/usetoast";
import axios from "@/api";
import CampaignForm from "@/components/CampaignForm.vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter();
const toast = useToast();

let resetDraft: (() => void) | null = null;
function onDraftInit(fn: () => void) {
	resetDraft = fn;
}

function submit(formData: Brandlift) {
	toast.removeAllGroups();

	// Use IRI for existing targets
	const payload: Brandlift = {
		...formData,
		campaign: {
			...formData.campaign,
			format: '/formats/Brandlift',
			targetGroups: formData.campaign.targetGroups.map(t => t['@id'] ?? {name: t}),
		}
	};

	axios
		.post('/campaigns/brandlifts', payload)
		.then(() => {
			resetDraft && resetDraft();

			router.push({
				name: "Campaigns",
				params: {
					success: 1
				}
			});

			notifyCampaignCreated();
		})
		.catch(err => {
			toast.add({
				severity: "error",
				summary: err.response.data["hydra:title"],
				detail: err.response.data["hydra:description"]
			});
		});
}

function notifyCampaignCreated() {
	toast.add({
		severity: "success",
		summary: "Campaign created",
		// detail: `Created campaign [${campaign.format.name}] ${campaign.advertiser} - ${campaign.name}`,
		life: 3000,
	});
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CampaignForm, {
    draft: "",
    onDraftInit: onDraftInit,
    onSubmit: submit
  }))
}
}

})